import React from 'react';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import {motion} from 'framer-motion'
 
import './Chef.css';

const Chef = () => (
  <div className='chef w-full min-h-screen  relative py-44'>
  <img src={images.bg} alt="" className='w-full h-[198vh] -z-[2] sm:h-full absolute top-0 right-0 left-0 bottom-0'/>
  <div className="div w-[80%] m-auto flex flex-col sm:flex-row justify-between items-center">
    <motion.div
       whileInView={{y:[-100, 0], opacity: [0,1]}}
    transition={{duration: 0.8, type: 'spring'}}
     className="left basis-[100%] sm:basis-[40%] mb-8">
        <img src={images.chef} alt="" className='w-full' />
    </motion.div>
    <motion.div 
     whileInView={{y:[100, 0], opacity: [0,1]}}
    transition={{duration: 0.8, type: 'spring'}}
     className="basis-[100%] right sm:basis-[40%]">
          <SubHeading title="Chef's Word" />
          <h1 className='text-yellow-200 font-semibold font-main text-3xl'>What We Believe In</h1>
          <div className="div mb-24 mt-14">
            <div className="div flex items-baseline">
              <img src={images.quote} alt="" />
              <p className='text-white'>Come dine at our tables and get of meals</p>
            </div>
               <p className='text-white'>you did not know could taste this good...with our experienced chefs you will be eating you money's worth,our reputation precedes us </p>
          </div>
    <div className="div">
        <p className='text-yellow-200 text-4xl mb-2 font-main'>Kevin Luo</p>
        <p className='text-white mb-12'>Chef & Founder</p>
        <img src={images.sign} alt="" />
    </div>
    </motion.div>
  </div>
    
  </div>
);

export default Chef;
